import styled from "@emotion/styled";

export const Container = styled("div")(() => ({
  maxWidth: 1500,
  margin: "0 auto",
  padding: "0 1rem",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  width: "100%",
}));
